var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddElementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E64B38;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,2.8c-0.2-0.2-0.4-0.2-0.6,0l-0.7,0.7l-0.7-0.7c-0.2-0.2-0.4-0.2-0.6,0s-0.2,0.4,0,0.6l0.7,0.7l-0.7,0.7 c-0.2,0.2-0.2,0.4,0,0.6c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1l0.7-0.7l0.7,0.7c0.1,0.1,0.2,0.1,0.3,0.1 c0.1,0,0.2,0,0.3-0.1c0.2-0.2,0.2-0.4,0-0.6l-0.7-0.7l0.7-0.7C14.3,3.3,14.3,3,14.2,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,12c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h0.3 v1.8h-0.3c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h1.3c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4h-0.2V12H13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,0h-5C9.5,0,8.8,0.7,8.8,1.6v5c0,0.9,0.7,1.6,1.6,1.6h5c0.9,0,1.6-0.7,1.6-1.6v-5C17,0.7,16.3,0,15.4,0z  M16,6.6c0,0.3-0.3,0.6-0.6,0.6h-5c-0.3,0-0.6-0.3-0.6-0.6v-5c0-0.3,0.3-0.6,0.6-0.6h5C15.7,1,16,1.3,16,1.6V6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.6,8.2h5c0.9,0,1.6-0.7,1.6-1.6v-5C8.2,0.7,7.5,0,6.6,0h-5C0.7,0,0,0.7,0,1.6v5C0,7.5,0.7,8.2,1.6,8.2z  M1,1.6C1,1.3,1.3,1,1.6,1h5c0.3,0,0.6,0.3,0.6,0.6v5c0,0.3-0.3,0.6-0.6,0.6h-5C1.3,7.2,1,6.9,1,6.6V1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,8.8H1.6C0.7,8.8,0,9.5,0,10.4v5C0,16.3,0.7,17,1.6,17h13.8c0.9,0,1.6-0.7,1.6-1.6v-5 C17,9.5,16.3,8.8,15.4,8.8z M16,15.4c0,0.3-0.3,0.6-0.6,0.6H1.6C1.3,16,1,15.7,1,15.4v-5c0-0.3,0.3-0.6,0.6-0.6h13.8 c0.3,0,0.6,0.3,0.6,0.6V15.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddElementIcon);
export default __webpack_public_path__ + "static/media/add-element-icon.313134690ae251312ba8ab7f701027fb.svg";
export { ForwardRef as ReactComponent };